export const CODE_LANGUAGE_OPTIONS = [
  { label: 'Python', value: 'python' },
  { label: 'Pascal', value: 'pascal' },
  { label: 'Java', value: 'java' },
]

const FALLBACK_CODE_LANGUAGES = CODE_LANGUAGE_OPTIONS.map((item) => item.value)

export const isCodeExecutionEnabled = (value) =>
  value === undefined || value === null || value === '' || value === true || value === 1 || value === '1'

export const normalizeCodeLanguages = (value) => {
  const nextValue = Array.isArray(value) ? value : []
  const allowedValues = new Set(FALLBACK_CODE_LANGUAGES)
  const normalized = nextValue
    .map((item) => String(item))
    .filter((item, index, array) => allowedValues.has(item) && array.indexOf(item) === index)

  return normalized.length ? normalized : FALLBACK_CODE_LANGUAGES
}

export const normalizeDefaultCodeLanguage = (value, languages = FALLBACK_CODE_LANGUAGES) => {
  const normalizedLanguages = normalizeCodeLanguages(languages)
  const normalizedValue = value ? String(value) : ''

  return normalizedLanguages.includes(normalizedValue)
    ? normalizedValue
    : normalizedLanguages[0]
}

export const getCodeLanguageLabel = (value) =>
  CODE_LANGUAGE_OPTIONS.find((item) => item.value === value)?.label ?? value
